<template>
  <span class="editor-content-image__edit-wrapper">
    <span v-for="(group, index) in editGroup" :key="index" class="group-edits">
      <EditorEditButton
        v-for="button in group"
        :key="button.name"
        :icon="button.icon"
        :class="{ active: isActive(button) }"
        :disabled="isDisabled(button)"
        @click="emit(button.emit, button.name)"
      ></EditorEditButton>
    </span>
  </span>
</template>

<script setup>
const props = defineProps({
  activities: { type: Array, default: () => [] },
  disabledOptions: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:position', 'import', 'delete']);

const editGroup = [
  [
    {
      name: 'align-left',
      icon: 'editor/pos-left',
      emit: 'update:position',
      group: 'align',
    },
    {
      name: 'align-center',
      icon: 'editor/pos-center',
      emit: 'update:position',
      group: 'align',
    },
    {
      name: 'align-right',
      icon: 'editor/pos-right',
      emit: 'update:position',
      group: 'align',
    },
  ],
  [
    {
      name: 'float-left',
      icon: 'editor/float-left',
      emit: 'update:position',
      group: 'float',
    },
    {
      name: 'float-right',
      icon: 'editor/float-right',
      emit: 'update:position',
      group: 'float',
    },
  ],
  [
    {
      name: 'import',
      icon: 'editor/import',
      emit: 'import',
    },
    {
      name: 'delete',
      icon: 'editor/delete',
      emit: 'delete',
    },
  ],
];

const isActive = (button) => {
  return (
    props.activities.includes(button.name) &&
    !props.disabledOptions.includes(button.group)
  );
};

const isDisabled = (button) => {
  return props.disabledOptions.includes(button.group);
};
</script>
